import FqApi from '@/services/fq-api'

export default {
  async getUsers(filter) {
    const url = '/user/list'
    const result = await FqApi.post(url, filter)
    return result.data
  },

  async getUser(id) {
    const result = await FqApi.get(`/user/${id}`)
    return result.data
  },

  putUser(user, deepdiff) {
    if (deepdiff) {
      user.deepDiff = JSON.stringify(deepdiff)
    }
    return FqApi.put(`/user/${user.userId}`, user)
  },

  resetPassword(param) {
    return FqApi.post('/user/resetPassword', param)
  },

  async getNewEntity() {
    const result = await FqApi.get('/user/new')
    return result.data
  },

  async postUser(user) {
    return FqApi.post('/user', user)
  },

  async checkEmailValidity(email, userId) {
    const result = await FqApi.get(`/user/checkEmailValidity?id=${userId}&email=${email}`)
    return result.data
  },

  async checkUsernameValidity(username, userId) {
    const result = await FqApi.get(`/user/checkUsernameValidity?id=${userId}&username=${username}`)
    return result.data
  },

  async getPasswordComplexity(password) {
    const result = await FqApi.post('auth/postPasswordComplexity', { password })
    return result.data
  },

  async getUsersByCompanyId(companyId, filter) {
    const url = `/user/list/${companyId}`
    const result = await FqApi.post(url, filter)
    return result.data
  }
}
